import { useState } from 'react';
import { useAuth } from '../../../Contexts/AuthProvider';
import LibModal from '../../../features/LibModal/LibModal';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { EditIcon } from '../../../utils/SVGIcon';
import { GetDate } from '../../../utils/Show';
import { TextCapitalize } from '../../../utils/TextFormatter';
import AddressModifyModal from '../Modals/AddressModifyModal';
import { handleSaveUserInfo } from '../UserProfileOperation';
import { useProfileInfo } from '../UserProfileProvider';
import UserAddressCard from './UserAddressCard';
import UserDobInfoCard from './UserDobInfoCard';
import UserGenderInfoCard from './UserGenderInfoCard';
import UserInfoCard from './UserInfoCard';

function UserInfoEditableArea() {
    const { authInfo } = useAuth();
    const { handleReset, formData } = useProfileInfo();
    const [addressType, setAddressType] = useState({ type: '' });

    const {
        firstName,
        lastName,
        dateOfBirth,
        organization,
        userName,
        primaryEmail,
        primaryPhone,
        addressAdministrative,
        addressBilling,
        addressTechnical,
        gender
    } = authInfo?.data || {};

    const { setMessage } = useTemplate();

    const { authStateUpdated } = useAuth();

    // --Handle for save click
    const handleSaveClick = (type) => {
        handleSaveUserInfo(type, formData)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                authStateUpdated();

                // --Reset the form data
                handleReset();
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error?.toString(0) });
            });
    };

    return (
        <div>
            <div className="flex flex-col gap-2.5">
                <div className="flex flex-col sm:flex-row gap-2.5">
                    <div className="w-full ">
                        <UserInfoCard
                            title="First Name"
                            name="firstName"
                            value={firstName}
                            saveClick={() => handleSaveClick('first-name')}
                        />
                    </div>
                    <div className="w-full ">
                        <UserInfoCard
                            title="Last Name"
                            name="lastName"
                            value={lastName}
                            saveClick={() => handleSaveClick('last-name')}
                        />
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-2.5">
                    <div className="w-full ">
                        <UserInfoCard
                            title="Email  Address"
                            name="primaryEmail"
                            value={primaryEmail}
                            saveClick={() => handleSaveClick('primary-email')}
                        />
                    </div>
                    <div className="w-full ">
                        <UserInfoCard
                            title="Phone Number"
                            name="primaryPhone"
                            value={primaryPhone}
                            saveClick={() => handleSaveClick('primary-phone')}
                        />
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-2.5">
                    <div className="w-full ">
                        <UserInfoCard
                            title="Username"
                            name="userName"
                            value={userName}
                            saveClick={() => handleSaveClick('user-name')}
                        />
                    </div>
                    <div className="w-full ">
                        <UserInfoCard
                            title="Organization"
                            name="organization"
                            value={organization}
                            saveClick={() => handleSaveClick('organization')}
                        />
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-2.5">
                    <div className="w-full ">
                        <UserDobInfoCard
                            title="Date of Birth"
                            name="dateOfBirth"
                            value={GetDate(dateOfBirth) || '--'}
                            type="dob"
                            saveClick={() => handleSaveClick('dob')}
                        />
                    </div>
                    <div className="w-full ">
                        <UserGenderInfoCard
                            title="Gender"
                            name="gender"
                            value={gender}
                            saveClick={() => handleSaveClick('gender')}
                        />
                    </div>
                </div>
                {/* <div className="w-full">
                    <UserInfoCard
                        title="Address"
                        name="primaryAddress"
                        value={primaryAddress || '--'}
                        saveClick={() => handleSaveClick('primary-address')}
                    />
                </div> */}

                <div className="w-full">
                    <UserAddressCard
                        title="Administrative Address"
                        name="primaryAddress"
                        value={
                            [addressAdministrative?.organization, addressAdministrative?.address]
                                .filter((d) => !!d)
                                .join(', ') || '--'
                        }
                        // saveClick={() => handleSaveClick('primary-address')}
                        customAction={
                            <button
                                type="button"
                                onClick={() => setAddressType('administrative')}
                                className="flex justify-center items-center  h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full"
                            >
                                <EditIcon />
                            </button>
                        }
                    />
                </div>
                <div className="w-full">
                    <UserAddressCard
                        title="Billing Address"
                        name="primaryAddress"
                        value={
                            [addressBilling?.organization, addressBilling?.address]
                                .filter((d) => !!d)
                                .join(', ') || '--'
                        }
                        // saveClick={() => handleSaveClick('primary-address')}
                        customAction={
                            <button
                                type="button"
                                onClick={() => setAddressType('billing')}
                                className="flex justify-center items-center  h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full"
                            >
                                <EditIcon />
                            </button>
                        }
                    />
                </div>
                <div className="w-full">
                    <UserAddressCard
                        title="Technical Address"
                        name="primaryAddress"
                        value={
                            [addressTechnical?.organization, addressTechnical?.address]
                                .filter((d) => !!d)
                                .join(', ') || '--'
                        }
                        // saveClick={() => handleSaveClick('primary-address')}
                        customAction={
                            <button
                                type="button"
                                onClick={() => setAddressType('technical')}
                                className="flex justify-center items-center  h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full"
                            >
                                <EditIcon />
                            </button>
                        }
                    />
                </div>
                {/* <div className="flex gap-2.5">
                    <div className="w-full ">
                        <UserInfoCard title="Password" name="password" value="**************" />
                    </div>
                    <div className="w-full ">
                        <UserInfoCard title="Note" name="note" value="This is the Last Note" />
                    </div>
                </div> */}

                {/* modals */}
                {addressType?.length ? (
                    <LibModal
                        title={`Update ${TextCapitalize(addressType)} Address`}
                        setOpen={setAddressType}
                    >
                        <AddressModifyModal
                            data={authInfo?.data?.[`address${TextCapitalize(addressType)}`]}
                            type={addressType || ''}
                            closeModal={() => setAddressType('')}
                        />
                    </LibModal>
                ) : null}
            </div>
        </div>
    );
}

export default UserInfoEditableArea;
